export default __webpack_public_path__ + "static/media/rsa-logo.324c8d53.svg";